import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective, BsModalRef } from 'ngx-bootstrap/modal';
import {DataTableDirective} from 'angular-datatables';
import {Subject} from "rxjs";
import {BackendApiService} from '../services/backend-api.service';
import { BackendSocketService } from '../services/backend-socket.service';
import {ActivatedRoute, Router,NavigationEnd} from '@angular/router';
import { CommonService } from '../services/common.service';
import _ from "lodash";
import * as moment from 'moment';
import { NgForm }   from '@angular/forms';
import { interval } from 'rxjs'; 
import * as $ from 'jquery';


@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  historyData  = [];
  historyRange = [];
  constructor(private route: ActivatedRoute,
    private router: Router,
    private backendApiService: BackendApiService,
    private commonService: CommonService,
    private backendSocketService: BackendSocketService) { }

  fromDate: any;
  badlaInstruments = [];
  allScript = [];
  withoutFilterScript = [];
  instrumentCategory = [
    {name : 'ALL'}, 
    {name : 'COPPER'}, 
    {name : 'CRUD'}, 
    {name : 'SILVER'}, 
    {name : 'GOLD'}, 
    {name : 'GAS'} 
  ];
  selectedScript = null;
  selectedBadlaType = 'ALL';
  sDate: any;
  selectedDate :any;
  selectedDateE : any;
  eDate: any;
  Toast = {
    type: '',
    title: '',
    timeout: 0,
    body: ''
  };
  minLTPBadla = 0;
  maxLTPBadla = 0;
  minBuyBadla = 0;
  maxBuyBadla = 0;
  minSellBadla = 0;
  maxSellBadla = 0;
  badlaCategory = "daywise"
  
  ngOnInit(): void {
    //this.getHistory();
    this.getAllScript();
    let ePreShow = moment().format("YYYY-MM-DD");
    if(this.badlaCategory == "daywise"){
      let fiveSdate = moment().subtract(5, "days").format("YYYY-MM-DD")
      this.sDate = fiveSdate; 
      this.eDate = ePreShow
      this.selectedDate = fiveSdate;  
      this.selectedDateE = ePreShow;
    }else{
      this.sDate = ePreShow; 
      this.selectedDate = ePreShow;  
    }


  }

  getHistory(){
    let newDate = this.selectedDate;
    if(this.selectedDate['year']){
      newDate = this.selectedDate['year'] + "-" + this.selectedDate['month'] + "-"  + this.selectedDate['day'] 
    }
    let data = {
      "instrumentId":this.selectedScript,
      "date" : moment(newDate).format("YYYY-MM-DD")
    }
    
    this.backendApiService.getHistoryByDay(data).subscribe(response => {
      if(response.status == true){
        if(response['data']['length'] > 0){
          let historyData = _.map(response['data'], function (resIns) {
            return resIns['historyData'];
          });  
          
          let minLTPBadla = Math.min(...historyData[0].map(item => item.finalBadla));
          let maxLTPBadla = Math.max(...historyData[0].map(item => item.finalBadla));
          let minBuyBadla = Math.min(...historyData[0].map(item => item.finalBadlaBuy));
          let maxBuyBadla = Math.max(...historyData[0].map(item => item.finalBadlaBuy));
          let minSellBadla = Math.min(...historyData[0].map(item => item.finalBadlaSell));
          let maxSellBadla = Math.max(...historyData[0].map(item => item.finalBadlaSell));
          
          this.minLTPBadla = minLTPBadla;
          this.maxLTPBadla = maxLTPBadla;
          this.minBuyBadla = minBuyBadla;
          this.maxBuyBadla = maxBuyBadla;
          this.minSellBadla= minSellBadla;
          this.maxSellBadla= maxSellBadla;


          this.historyData = historyData[0];
        }else{
          this.historyData = []
          this.minLTPBadla =  0;
          this.maxLTPBadla =  0;
          this.minBuyBadla =  0;
          this.maxBuyBadla =  0;
          this.minSellBadla=  0;
          this.maxSellBadla=  0;
        }
      }else{
        this.historyData = []
        this.minLTPBadla =  0;
        this.maxLTPBadla =  0;
        this.minBuyBadla =  0;
        this.maxBuyBadla =  0;
        this.minSellBadla=  0;
        this.maxSellBadla=  0;
      }
      setTimeout(() => {
        // ADD THIS
        this.dtTrigger.next();
        this.dtOptions = {
          pagingType: 'full_numbers'
        };
                
    }, 100);
    });
  }

  dayWiseGetHistory(){
    let newDateS = this.selectedDate;
    if(this.selectedDate['year']){
      newDateS = this.selectedDate['year'] + "-" + this.selectedDate['month'] + "-"  + this.selectedDate['day'] 
    }

    let newDateE = this.selectedDateE;
    if(this.selectedDateE['year']){
      newDateE = this.selectedDateE['year'] + "-" + this.selectedDateE['month'] + "-"  + this.selectedDateE['day'] 
    }

    let data = {
      "instrumentId":this.selectedScript,
      "sDate" : moment(newDateS).format("YYYY-MM-DD"),
      "eDate" : moment(newDateE).format("YYYY-MM-DD")
    }

    this.backendApiService.getHistoryByRange(data).subscribe(response => {
      if(response.status == true){
        if(response['data']['length'] > 0){
          this.historyRange = response['data'];
        }else{
          this.historyRange = []
        }
      }
    })    
  }

  getAllScript(){
    let data = {
      "isActive":true
    }
    this.backendApiService.liveBadlaInstruments(data).subscribe(response => {
      if(response.status == true){
        //this.badlaInstruments= response.data;
        this.allScript = response.data;
        this.allScript = _.sortBy(this.allScript, 'settingName');

        this.withoutFilterScript = response.data;
        this.withoutFilterScript = _.sortBy(this.withoutFilterScript, 'settingName');       
      }
    }) 
  }

  badlaTypeChnage(type){
    console.log('type+++',type);
    this.allScript = [];
    if(type == "ALL"){
      this.allScript = this.withoutFilterScript;
    }else{
     let filterCategoryWise =  _.filter(this.withoutFilterScript, function(o) {
        if(o['badlaType'] == type){
          return o;
        }
        }
      );
      this.allScript = filterCategoryWise;
    }
  } 

  badlaCategoryChange(category){
    let ePreShow = moment().format("YYYY-MM-DD");
    if(this.badlaCategory == "daywise"){
      let fiveSdate = moment().subtract(5, "days").format("YYYY-MM-DD")
      this.sDate = fiveSdate; 
      this.eDate = ePreShow
      this.selectedDate = fiveSdate;  
      this.selectedDateE = ePreShow;
    }else{
      this.sDate = ePreShow; 
      this.selectedDate = ePreShow;  
    }
  }

  clearDate(e){
    if(e.target.value === ''){
    }
  }
  onDateSelect(e) {
  }
  findHistory(){
    if(!this.selectedScript){
      this.showToster('Error', 'error', "Please select instrument.");
    }else{
      if(this.badlaCategory == "daywise"){
        this.dayWiseGetHistory();
      }else{
        this.getHistory();
      }
    }
  }

  showToster(title, type, message) {
    this.Toast.title = title;
    this.Toast.type = type;
    this.Toast.body = message;
    this.commonService.popToast(type, title, 1500, message);
  }

}
